import { NavLink } from "react-router-dom";
// import ButtonPrimary from "./ButtonPrimary";
import ProjectCard from "./ProjectCard";
import Button from "./Button";
import ArrowUpRight from "./icons/ArrowUpRight";
import AppearOnScroll from "./AppearOnScroll";
import ListItem from "./ListItem";

function Projects() {
    let projects = require("../projects.json");
    const favouriteProjects = projects.filter(p => p.fav);
    console.log("favouriteProjects:", favouriteProjects);
    return (
        <AppearOnScroll delay={0.2}>
        <div id="Projects" className="relative ">
            
            <section className="relative flex flex-col items-start gap-8 w-full">
                
                    <h2 id="projects" className="font-display font-medium text-xl md:text-3xl text-dark">Favourite projects</h2>
                
                <div className="flex flex-col space-y-24 hidden md:block">
          
                        {
                            favouriteProjects.map((project, idx) => {
                            const isMirrored = idx % 2 === 1;
                            return (
                            <ProjectCard key={idx} project={project} isMirrored={isMirrored}/>
                            
                            );
                        })}
                    
                </div>
                <div className="flex flex-col gap-8 block md:hidden">
                    {
                        favouriteProjects.map((project, idx) => {
                        return (
                         <ListItem key={idx} project={project} />
                        );
                    })}
                    </div>
                
                <div className="flex w-full items-center justify-center md:pt-12">
                <AppearOnScroll delay={0}>
                <NavLink to={"/Allprojects"}>
                <Button icon={ArrowUpRight} iconPosition="right" variant="primary" className='group'>View more projects</Button>
                </NavLink>
                </AppearOnScroll>
                
                </div>
                
            </section>
            
        </div>
        </AppearOnScroll>
    );
  }
  
  export default Projects;